import moment from "moment";

const formatDayMonth = (date: string): string => moment(date).format('D. MMM');

export const formatTaskHoursLogDate = (date?: string | null): string | null => {
    if (!date) {
        return null;
    }
    const parsed = moment(date);
    return parsed.isValid() ? formatDayMonth(date) : null;
};

export const getWorkOrderTaskUserTotalHours = (
    user: { ordinaryHours: number; overTime50: number; overTime100: number },
): number => Number(user.ordinaryHours) + Number(user.overTime50) + Number(user.overTime100);